import React, { useState } from "react";
import useChangeLanguage from "../../../logic/useChangeLanguage.js";

const SearchBox = ({ onSearch, searchResults, isSearching }) => {
  const [searchValue, setSearchValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { getArticleTitle, getArticleBody, _t } = useChangeLanguage();

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value.trim().length > 1) {
      onSearch(value);
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleSelectSuggestion = (article) => {
    setSearchValue("");
    setShowSuggestions(false);
    window.location.href = "/detail_new/" + article.id;
  };

  const handleSearchOutside = (query) => {
    const googleSearchUrl = `https://www.google.com/search?q=${encodeURIComponent(
      query
    )}`;
    window.open(googleSearchUrl, "_blank");
  };

  return (
    <div className="search-box" style={{ position: "relative" }}>
      <input
        type="text"
        placeholder={_t("search_placeholder")}
        value={searchValue}
        onChange={handleChange}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
      />
      <i className="pi pi-search"></i>

      {showSuggestions && searchResults.length > 0 && (
        <div className="search-suggestions">
          {isSearching && (
            <div className="search-suggestion-item">{_t("searching")}</div>
          )}
          {!isSearching &&
            searchResults.map((article) => (
              <div
                key={article.id}
                className="search-suggestion-item"
                onClick={() => handleSelectSuggestion(article)}
              >
                <strong>{getArticleTitle(article)}</strong>
                <small>
                  {new Date(article.created_at).toLocaleDateString("fr-FR")}
                </small>
              </div>
            ))}
        </div>
      )}

      {showSuggestions &&
        !isSearching &&
        searchResults.length === 0 &&
        searchValue.length > 2 && (
          <div className="search-suggestions">
            <div className="search-suggestion-item">
              {_t("no_results_found")}
            </div>
            <div className="search-google">
              <button onClick={() => handleSearchOutside(searchValue)}>
                {_t("search_with_google")}
              </button>
            </div>
          </div>
        )}
    </div>
  );
};

export default SearchBox;
